module.exports = __webpack_public_path__ + "static/media/4.167a8c26.svg";